import $ from 'cash-dom'

if (window.Pura?.template?.suffix === 'cover-eligibility') {
  const serialChecker = $('[data-component="serial-number-checker"]')
  const input = serialChecker.find('input[name="serial_number"]')
  const button = serialChecker.find('[data-action="check-serial"]')
  const result = serialChecker.find('[data-element="serial-checker-result"]')

  const isSerialInRange = (input: string): boolean => {
    const cleaned = input.toUpperCase().replace(/\s/g, '')
    const normalized = cleaned.startsWith('JX') ? cleaned : `JX${cleaned}`

    const isValidFormat = /^JX(23|24)\d{7}$/.test(normalized)

    const ranges = [
      { min: 'JX230000001', max: 'JX230801425' },
      { min: 'JX240000001', max: 'JX240049959' }
    ]

    return isValidFormat && ranges.some(r => normalized >= r.min && normalized <= r.max)
  }

  button.on('click', () => {
    const serial = input.val()?.toString().trim() || ''
    const isValid = isSerialInRange(serial)

    if (isValid) {
      window.location.href = '/products/pura-4-replacement-cover'
    } else {
      result.removeClass('hidden')

    }
  })

  input.on('input', () => {
    result.addClass('hidden')
  })
}